import React from 'react';
import Anchor from './Anchor';
import { string, object, any, bool } from 'prop-types';

const MenuItem = ({
  item,
  focus,
  isAccessByUPDownKey,
  anchorClasses,
  imageOthers,
  others
}) => {
  return (
    <li
      className="menuList"
      {...(isAccessByUPDownKey ? { role: 'menuitem' } : '')}
    >
      <Anchor
        isAccessByUPDownKey={isAccessByUPDownKey}
        title={item.name}
        icon={item.icon}
        className={anchorClasses}
        others={others}
        focus={focus}
        imageOthers={imageOthers}
      />
    </li>
  );
};

MenuItem.propTypes = {
  item: object,
  focus: any,
  isAccessByUPDownKey: bool,
  anchorClasses: string,
  imageOthers: object,
  others: object
};

MenuItem.defaultProps = {
  item: {},
  focus: 0,
  isAccessByUPDownKey: false,
  anchorClasses: '',
  imageOthers: {},
  others: {}
};
export default MenuItem;
